import React, { useRef } from "react";
import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import AddandEditStyle from "../../style/Pages/AddEditCompanyPage.module.css";
import { BsUpload } from "react-icons/bs";
import { RiDeleteBinLine } from "react-icons/ri";
import PageInputStyle from "../../components/ui/input/PagesInput/PagesInput.module.css";
import PageInputField from "../../components/ui/input/PagesInput/PagesInput";
import Button from "../../components/ui/buttons/Button";
import Loader from "../../components/ui/Loader/Loader";
import { useAddCompany } from "../../hooks/useCompany";

const AddCompanyPage = () => {
  // const [selectedImage, setselectedImage] = useState(null);
  const fileInputRef = useRef(null);
  const {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    selectedImage,
    setSelectedImage,
  } = useAddCompany();
  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleDeleteImage = () => {
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    handleInputChange({
      target: { name: "company_logo", value: "" },
    });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) return;

    setSelectedImage(URL.createObjectURL(file)); // for preview
    handleInputChange({
      target: { name: "company_logo", value: file }, // store file
    });
  };
  return (
    <MainLayout>
      <div className={mainStyle.mainPageHeader}>
        <div>
          <p className={mainStyle.mainHeading}>Add Company:</p>
        </div>
        <div className={mainStyle.mainPageButtons}></div>
      </div>
      <div className={mainStyle.mainContentView} style={{ height: "84%" }}>
        <div className={mainStyle.mainContentViewsb}>
          <div className={mainStyle.mainContentCard}>
            <p className={mainStyle.aboutPageContent}>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Use this page to
              register a new company or organization to start using the chat
              platform for your team communication.
            </p>
            <div className={mainStyle.mainContentForm}>
              <div className={mainStyle.mainContentFormSplit}>
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Company<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <div className={AddandEditStyle.companyCardView}>
                    <div className={AddandEditStyle.companyCardViewsb}>
                      <div
                        className={AddandEditStyle.companyCardViewImage}
                        onClick={handleImageClick}
                      >
                        {selectedImage ? (
                          <img src={selectedImage} alt="img" />
                        ) : (
                          <div className={AddandEditStyle.uploadImageDiv}>
                            <BsUpload />
                            Upload Your Organization Logo
                          </div>
                        )}
                      </div>
                      <input
                        type="file"
                        accept="image/*"
                        name="company_logo"
                        onChange={handleImageUpload}
                        ref={fileInputRef}
                        style={{ display: "none" }}
                      />
                      <div className={AddandEditStyle.companyCardViewDelete}>
                        <RiDeleteBinLine
                          className={`${
                            AddandEditStyle.companyCardViewDeleteIcn
                          } ${
                            !selectedImage
                              ? AddandEditStyle.disabledDeleteIcon
                              : ""
                          }`}
                          onClick={selectedImage ? handleDeleteImage : null}
                        />
                      </div>
                    </div>
                  </div>
                  {error.company_logo && (
                    <span className={mainStyle.errorMsg}>
                      {error.company_logo}
                    </span>
                  )}
                </div>

                <p className={mainStyle.contentGuideOrd}>
                  Note : This logo will be used to help users easily identify
                  your company across the platform. A recognizable logo enhances
                  brand visibility and ensures a consistent company presence in
                  all user interactions.
                </p>
              </div>
              <div className={mainStyle.mainContentFormSplit}>
                <PageInputField
                  label="Company Name"
                  name="company_name"
                  placeholder="e.g., company name"
                  required
                  value={formData.company_name || ""}
                  onChange={handleInputChange}
                  error={error.company_name}
                />
                <PageInputField
                  label="Company Email"
                  name="company_email"
                  placeholder="e.g., company@example.com"
                  required
                  value={formData.company_email || ""}
                  onChange={handleInputChange}
                  error={error.company_email}
                />
              </div>
              <div className={mainStyle.mainContentFormSplit}>
                <PageInputField
                  label="Company Phone"
                  name="company_phone_num"
                  placeholder="e.g., 876543210"
                  required
                  value={formData.company_phone_num || ""}
                  onChange={handleInputChange}
                  error={error.company_phone_num}
                />
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Address<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <textarea
                    className={PageInputStyle.input}
                    name="company_address"
                    placeholder="e.g.,  House No, Locality, Landmark, City, PIN"
                    value={formData.company_address || ""}
                    onChange={handleInputChange}
                  />
                  {error.company_address && (
                    <span className={mainStyle.errorMsg}>
                      {error.company_address}
                    </span>
                  )}
                </div>
              </div>
              <div className={mainStyle.mainContentFormSplit}>
                <PageInputField
                  label="City"
                  name="city"
                  placeholder="e.g., Enter city  "
                  required
                  value={formData.city || ""}
                  onChange={handleInputChange}
                  error={error.city}
                />
                <PageInputField
                  label="State"
                  name="state"
                  placeholder="e.g., Enter state  "
                  required
                  value={formData.state || ""}
                  onChange={handleInputChange}
                  error={error.state}
                />
                <PageInputField
                  label="Pincode"
                  name="pincode"
                  placeholder="e.g., Enter pincode"
                  required
                  value={formData.pincode || ""}
                  onChange={handleInputChange}
                  error={error.pincode}
                />
              </div>
              <div
                className={mainStyle.mainButtonDiv}
                style={{ width: "100%" }}
              >
                <Button onClick={handleSubmit}>
                  {" "}
                  {loading ? <Loader /> : "Submit"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddCompanyPage;
